import React, { useState } from 'react'
import PropTypes from 'prop-types'

import PoweredBy from 'components/powered-by'
import RateTableFooterDisclosure from 'components/RateTableFooterDisclosure/Disclosure'
import FooterLinks from 'components/footer-links'

import FullRateTableAppBase from './base'
import DefaultHeader from '../components/default-header'
import styles from './styles.module.scss'

const FullRateTableApp = ({ theme, ...props }) => {
  const [isDisclosureOpen, setIsDisclosureOpen] = useState(false)

  return (
    <div className={styles.fullDefaultRateTableRoot}>
      <div className={styles.headerContainer}>
        <PoweredBy className={`mb-8 ${styles.displayDesktop}`} />
        <DefaultHeader {...props} setIsDisclosureOpen={setIsDisclosureOpen} />
      </div>
      <FullRateTableAppBase {...props} theme={theme} />
      <FooterLinks containerClassName={styles.footerLinks} small />
      <PoweredBy className={`${styles.displayMobile}`} stylesClassName="disclaimer" />
      <RateTableFooterDisclosure
        slug="personal.landing.footer"
        isOpen={isDisclosureOpen}
        toggleDisclosure={() => setIsDisclosureOpen((prevOpen) => !prevOpen)}
      />
    </div>
  )
}

FullRateTableApp.propTypes = {
  theme: PropTypes.string,
}

export default FullRateTableApp
